import { EUnavailableReason } from '../../../ServicePickerWidget';

import { MicrofrontEventSender } from './microfrontEventSender';
import { PUBLICATION_UNAVAILABLE_EVENT_NAME } from './constants';

export const sendPublicationUnavailableEvent = (reason: EUnavailableReason) => {
  const event = new MicrofrontEventSender(PUBLICATION_UNAVAILABLE_EVENT_NAME, reason);

  event.dispatch();
};
